// extracted by mini-css-extract-plugin
module.exports = {"tag":"ADEvent_tag_S3mUa","idea":"ADEvent_idea_qLWOy"};